export const getSpanFieldValue = (
  title: string,
  value: string | number,
  id: string
) => `<span
        data-description="${title}"
        data-type="addedField"
        data-value="${value}"
        data-id="${id}"
        contentEditable="false"
      >
      ${title}
      </span>`
